import React from "react";
import Nav from "./components/Nav";

import Footer from "./components/Footer";
import AboutSide from "./components/AboutSide";


function About() {
  return (
    <>
      <Nav />
      <div className="container pt-20 grid xl:grid-cols-3 justify-center ">
        <div className="xl:col-span-2">
          <h2>About us</h2>
          <p className="py-4">
            Well hello there. And nice to meet you. We are experts in Web3,
            software and collectibles, working on the future, today.
          </p>
          <p className="py-4">
            Starting with: taking collecting stamps, also known as philately to
            the next level. We are a collaboration between PROxID, Concordium,
            and Royal Joh. Enschedé, all with our own expert skill set. Our
            digital crypto stamps are little pieces of digital art, thanks to
            the designing and printing of Royal Joh. Enschedé. PROxID's
            technology and know-how takes care of everything around the buying,
            collecting, and trading, all backed up by the super-secure
            Concordium blockchain with ID framework technology and the Polygon
            blockchain.
          </p>
          <p className="py-4">
            We started our journey in 2021, as pioneers of the fusion of
            physical objects and NFTs. Phygitals are digital twins of a physical
            object. On our platform you can create, collect and trade those
            digital twins as NFT on the blockchain. As a collector, you can
            learn how to digitise your hobby in a safe environment and connect
            to other collectors worldwide. If you’re already tech-savvy, you
            will definitely admire the stunning features as an addition to your
            world!
          </p>
          <p className="py-4">
            Collaboration is at the heart of Ciphers.me. We have worked closely
            together with our partners, to explore new possibilities, driven by
            shared interests, since 2022. Together we aim to make the digital
            world safer, more reliable, fun and connective!
          </p>
          <p className="py-4">
            By combining our digital smarts with our partners' printing skills,
            we've created a one-stop solution. This opens up exciting chances
            for postal organisations worldwide to breathe new life into stamp
            collecting and celebrate the cool history of philately.
          </p>
          <h2 className="pt-8">So, welcome to Ciphers.me.</h2>
          <h3 className="pt-4">Let’s create something beautiful together.</h3>
        </div>
        <div className="col-span-1">
          <AboutSide />
        </div>
      </div>
      <Footer />
    </>
  );
}

export default About;
